import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AgentState } from "./types";
import { AgentValue } from "../../../services/api/instances/agentsApi/types";
import {
  createAgentReducerBuilder,
  updateAgentReducerBuilder,
} from "./reducers";

const initialState: AgentState = {
  agentValue: null,
  isAgentLoading: false,
};

const agentSlice = createSlice({
  name: "agent",
  initialState,
  reducers: {
    setAgentValue: (state, action: PayloadAction<AgentValue>) => {
      state.agentValue = action.payload;
    },
    setAgentLoading: (state, action: PayloadAction<boolean>) => {
      state.isAgentLoading = action.payload;
    },
  },
  extraReducers: (builder) => {
    createAgentReducerBuilder(builder);
    updateAgentReducerBuilder(builder);
  },
});

export const agentReducers = agentSlice.reducer;
export const { setAgentValue, setAgentLoading } = agentSlice.actions;
